import { JsonObject, JsonProperty, AbstractModel } from 'projects/core/src/public-api';

@JsonObject('model.trello.TrelloObject')
export class TrelloObject extends AbstractModel {
    @JsonProperty(Number, 'id')
    id?: number;

    @JsonProperty(String, 'trelloId')
    trelloId?: string;

    @JsonProperty(String, 'name')
    name?: string;
}
